.chip {
  composes: text-label-overline from global;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--ds-space-xs);
  padding: var(--ds-space-xs) var(--ds-space-md);
  border-radius: var(--ds-radius-pill);
  white-space: nowrap;
  box-sizing: border-box;
}

.text {
  display: inline-block;
}

.icon {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  width: 12px;
  height: 12px;
}

.clickable {
  border: none;
  margin: 0;
  cursor: pointer;
}

.clickable:focus-visible {
  outline: var(--ds-stroke-focus) solid var(--ds-color-accent-primary);
  outline-offset: 2px;
}

.clickable:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* sun y label: padding-inline compacto */
.chip[data-variant="sun"],
.chip[data-variant="label"] {
  padding-inline: var(--ds-space-sm);
}

.chip[data-variant="sun"] {
  background: var(--ds-color-bg-page);
  color: var(--ds-color-text-hi);
  border: var(--ds-stroke-default) solid var(--ds-color-line-default);
}

.chip[data-variant="label"] {
  background: var(--ds-color-text-hi);
  color: var(--ds-color-text-on-primary);
}

.chip[data-variant="alert"] {
  background: var(--ds-color-status-warn-soft);
  color: var(--ds-color-status-warn);
}

.chip[data-variant="alarm"] {
  background: var(--ds-color-status-bad-soft);
  color: var(--ds-color-status-bad);
}

.chip[data-variant="ok"] {
  background: var(--ds-color-status-good-soft);
  color: var(--ds-color-status-good);
}

.chip[data-variant="online"] {
  background: var(--ds-color-status-good);
  color: var(--ds-color-text-inverse);
}

.chip[data-variant="no-disponible"] {
  background: var(--ds-color-status-bad);
  color: var(--ds-color-text-inverse);
}

.chip[data-variant="neutral"] {
  background: var(--ds-color-bg-elev-2);
  color: var(--ds-color-text-mute);
}

.chip[data-variant="accent"] {
  background: var(--ds-color-accent-primary-soft);
  color: var(--ds-color-accent-primary);
}

/* 24px es el mínimo de WCAG 2.5.8; el margen negativo se lo come para que el chip
   no crezca, igual que el min-height que documenta el Checkbox de este kit */
.iconButton {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  min-height: 24px;
  margin-block: -6px;
  margin-inline-end: -6px;
  padding: 0;
  border: none;
  background: none;
  color: inherit;
  cursor: pointer;
}

.iconButton:focus-visible {
  border-radius: var(--ds-radius-sub);
  outline: var(--ds-stroke-focus) solid var(--ds-color-accent-primary);
  outline-offset: 2px;
}
